import { createSelector } from 'reselect'

const sessionReducerInstalacionSelector = state => {
  return state.sessionReducer.getIn(["instalacion"])
} 
export const instalacionSelector = createSelector(
    sessionReducerInstalacionSelector, (instalacionField) => {
      // armo el objeto de instalación
      let myInstalacion  = {}
      if(instalacionField !== undefined)
      {
        instalacionField = instalacionField.toJS()

        myInstalacion.id = instalacionField.idInstalacion
        myInstalacion.logoSuperior = instalacionField.logoHorizontal
        myInstalacion.fondoLogin = instalacionField.fondoLogin
        myInstalacion.logoLogin=instalacionField.logoLogin
        myInstalacion.mostrarNombre = instalacionField.mostrarNombre

        // datos de contacto
        myInstalacion.datosContacto = {}
        myInstalacion.datosContacto.id = instalacionField.datosContacto.idDatosContacto
        
        if(instalacionField.datosContacto.idDatosContacto !== 0){
          myInstalacion.datosContacto.id = instalacionField.datosContacto.idDatosContacto
          myInstalacion.datosContacto.calle = instalacionField.datosContacto.calle || undefined
          myInstalacion.datosContacto.numero = instalacionField.datosContacto.numero
          myInstalacion.datosContacto.piso = instalacionField.datosContacto.piso
          myInstalacion.datosContacto.departamento = instalacionField.datosContacto.departamento
          myInstalacion.datosContacto.email = instalacionField.datosContacto.correo || undefined
          myInstalacion.datosContacto.telefono = instalacionField.datosContacto.telefono || undefined
          myInstalacion.datosContacto.facebook = instalacionField.datosContacto.facebook || undefined
          myInstalacion.datosContacto.twitter = instalacionField.datosContacto.twitter || undefined
          myInstalacion.datosContacto.instagram = instalacionField.datosContacto.instagram || undefined
        }

        myInstalacion.rubroTextil = instalacionField.rubroTextil
        myInstalacion.mostrarPrecioSugerido = instalacionField.mostrarPrecioSugerido
        myInstalacion.porcentajePrecioSugerido = instalacionField.porcentajePrecioSugerido
        myInstalacion.promosBandaDescuentos = instalacionField.promosBandaDescuentos
        myInstalacion.bandaDescuento = instalacionField.bandaDescuento

        myInstalacion.montoCompraMinimoPermitido = instalacionField.montoCompraMinimoPermitido
        myInstalacion.cobroDelivery = instalacionField.cobroDelivery
        myInstalacion.montoDelivery = instalacionField.montoDelivery
        
        //parametros tiempo control de actividad del usuario
        myInstalacion.tiempoActividadDelUsuario = instalacionField.tiempoActividadDelUsuario
        myInstalacion.tiempoDecisionPedidoBorrador = instalacionField.tiempoDelAvisoControlActividadDelUsuario

        myInstalacion.ocultarProductosAgotados = instalacionField.ocultarProductosAgotados

        let listaBandaDescuento = []

        instalacionField.listaBandaDescuento.forEach(bd => {
          let bandaDescuento = {}

          bandaDescuento.idBandaDescuento = bd.idBandaDescuento
          bandaDescuento.idBandaDescuentoPorcentaje = bd.idBandaDescuentoPorcentaje
          bandaDescuento.nombre = bd.nombre
          bandaDescuento.limiteInferior = bd.limiteInferior
          bandaDescuento.limiteSuperior = bd.limiteSuperior
          bandaDescuento.porcentajeDescuento = bd.porcentajeDescuento

          listaBandaDescuento.push(bandaDescuento)
        });

        myInstalacion.listaBandaDescuento = listaBandaDescuento
      }
      else{
        myInstalacion.id = 3
      }
      return myInstalacion;
  }
)

const sessionReducerResultadoAutenticacionSelector = state => state.sessionReducer.getIn(["resultadoAutenticacion"])
export const resultadoAutenticacionSelector = createSelector(
  sessionReducerResultadoAutenticacionSelector, (resultadoAutenticacionField) => {    
    return resultadoAutenticacionField.toJS()
  }
)

const sessionReducerUsuarioSelector = state => state.sessionReducer.getIn(["usuario"])
export const usuarioSelector = createSelector(
  sessionReducerUsuarioSelector, (usuarioField) => {   
    let myUsuario = undefined
    if(usuarioField)
    {
      let usuario = usuarioField.toJS()
      myUsuario = {}
      myUsuario.id = usuario.idUsuario
      myUsuario.nombreUsuario = usuario.nombreUsuario
      myUsuario.idCliente = usuario.idCliente
      myUsuario.idRol=usuario.idRol
    }

    return myUsuario
  }
)

const sessionReducerUsuarioAnonimoSelector = state => state.sessionReducer.getIn(["permiteUsuarioAnonimo"])
export const permiteUsuarioAnonimoSelector = createSelector(
  sessionReducerUsuarioAnonimoSelector, (usuarioAnonimoField) => {    
    return usuarioAnonimoField.toJS()
  }
)